import React from "react";
import styles from "./ChildHealth.module.css";
import ChildHealthWave from "../../../../components/UI/ChildHealthWave";
import ChildHealthDiamond from "../../../../components/UI/ChildHealthDiamond";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationContext } from "../../../../App";
import { useContext } from "react";

const ChildHealth = ({ data }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  return (
    <section className={styles.section} id="child-health-home">
      {/* <img
        className={styles.pattern}
        src="https://via.placeholder.com/1200x800/000000/333333?text=Pattern"
        alt="Pattern"
      /> */}
      <ChildHealthWave className={styles.pattern} />
      <img
        className={styles.patternTab}
        src="/img/patterns/child-health-tab.svg"
      />
      <img
        className={styles.patternTab2}
        src="/img/patterns/child-health-diamond.svg"
      />
      <img
        src="/img/icons/child-section-diamond.svg"
        className={styles.pattern2}
      />
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img
            className={styles.childAbsolute}
            src="/img/icons/child-health-rectangle.svg"
          />
          <img
            data-aos="fade-down"
            data-aos-delay="150"
            className={styles.mainImage}
            src={data?.listingItems[0]?.images[0]?.url}
            alt={data?.listingItems[0]?.images[0]?.imageTag}
          />
        </div>
        <div className={styles.content}>
          {data?.showTitle && (
            <div className={styles.titleFirst}>
              <h2
                data-aos="fade-right"
                data-aos-delay="150"
                dangerouslySetInnerHTML={{ __html: data?.title }}
              ></h2>
            </div>
          )}
          <h2
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.subtitle}
          >
            {data?.subTitle}
          </h2>
          <div className={styles.imageWrapper2}>
            <img
              className={styles.mainImage2}
              src={data?.listingItems[0]?.images[0]?.url}
              alt={data?.listingItems[0]?.images[0]?.imageTag}
              data-aos="fade-down"
                data-aos-delay="150"
            />
          </div>
          <div
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: data?.listingItems[0]?.homeDescription,
            }}
          />
          {/* <h4 className={styles.knowMore}>
            <p>View All</p>
            <img src="/img/icons/right-arrow-only.svg" />
          </h4> */}
          <button
            data-aos="fade-down"
            data-aos-delay="150"
            className={`${styles.button} bg-primary-500 primary-hover2 border-primary-500`}
            onClick={()=>{
               const yPos = window.scrollY;
            sessionStorage.setItem("scrollTargetY", yPos.toString());
            sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
            setIsBackNavigation(true)
              navigate(`/pages/${data?.listingItems[0]?.slug}`)}}
          >
            Know More
          </button>
        </div>
      </div>
    </section>
  );
};

export default ChildHealth;
